module.exports = __webpack_public_path__ + "img/renlian.f2d9f2c1.png";